export default __webpack_public_path__ + "roadmap-icon@2x.png";